import { BaseEcomSdkEnumsObj } from "@payair/e-com-common-sdk";
import { SrciEventListenerEnumsObj } from "../../enums/SrciEventListenerEnum";
import EventReporterService from "./EventReporterService";
import { serializeSrciTelemetry } from "../telemetry/SrciTelemetry";
/** @internal */
var EventReporter = /** @class */ (function () {
    function EventReporter() {
        var _this = this;
        this.sendEvent = function (eventType, additionalInfo, requestId) {
            var eventParams = {
                eventType: eventType,
                requestId: requestId,
                additionalInfo: additionalInfo,
            };
            try {
                _this.handleEvent(eventParams);
            }
            catch (_error) {
                // Telemetry must never interrupt the business flow.
            }
        };
    }
    EventReporter.prototype.reset = function () {
        this.transactionId = undefined;
        this.eventReporterService = undefined;
        this.merchantIdMastercard = "";
        this.merchantIdVisa = "";
    };
    EventReporter.prototype.initEventReporterService = function (pspName, transactionId, merchantIdMastercard, merchantIdVisa) {
        try {
            this.transactionId = transactionId;
            this.eventReporterService = new EventReporterService(pspName);
            this.merchantIdMastercard = merchantIdMastercard || "";
            this.merchantIdVisa = merchantIdVisa || "";
        }
        catch (_error) {
            this.reset();
        }
    };
    EventReporter.prototype.handleEvent = function (eventParams) {
        var srciEvent = {
            clientTimestamp: Date.now(),
            sdk: BaseEcomSdkEnumsObj.PAYAIR_SRCI_SDK,
            eventType: eventParams.eventType,
            additionalInfo: serializeSrciTelemetry(eventParams.eventType, eventParams.additionalInfo),
            requestId: eventParams.requestId,
            transactionId: this.transactionId ? this.transactionId : "",
            merchantId: [this.merchantIdMastercard, this.merchantIdVisa],
        };
        if (this.eventReporterService) {
            try {
                this.eventReporterService.reportEvent(srciEvent).catch(function () { return undefined; });
            }
            catch (_error) {
                // Continue with the browser event when backend reporting fails.
            }
        }
        try {
            window.dispatchEvent(new CustomEvent(SrciEventListenerEnumsObj.PAYAIR_SRCI_SDK_LISTENER, { detail: srciEvent }));
        }
        catch (_error) {
            // Browser listeners must not interrupt the business flow.
        }
    };
    return EventReporter;
}());
export default EventReporter;
